module.exports = __webpack_public_path__ + "img/offer-2023-04-desktop.bb23cdc5.png";